import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './CategoryACard.module.less';
import Button from '../../Button/Button';
import { CONTEXT } from '../../../config';
import _LogInView from '../../_LogInView/_LogInView';
import GameRate from '../GameRate/GameRate';
import { logging, logPostInfo } from '../../../actions/log';
import { getSoftType } from '../../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo }) => {
  const [isHover, setIsHover] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const handleApp = () => {
    history.push(
      `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`,
    );
    const source = logInfo ? logInfo.source : 'SoftCard_err';
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          ...logInfo,
          softid: soft?.packageName,
          versionCode: soft?.versionCode,
          softType: getSoftType(soft),
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
      }),
    );
  };

  return (
    // <_LogInView cardData={soft} logInfo={logInfo}>
    <div
      className={styles.category_a_card}
      onMouseMove={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={handleApp}
    >
      <div className="card_icon">
        <img src={soft.logoFile} />
        {soft?.androidType === '1' && <div className="card_icon_a" />}
      </div>
      <div className="card_info">
        <div className="card_info_title">
          <div className="game_title">{soft.softName}</div>
          {isHover && (
            <div
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              <Button
                soft={soft}
                info={{ btnStyle: 'black' }}
                logInfo={{ ...logInfo, softId: soft.softID }}
              />
            </div>
          )}
        </div>
        <div className="game_info">
          {/* <div>{soft.scoreRadio}%好评率</div> */}
          {soft?.scoreRadio > 70 ? (
            <div>{soft?.scoreRadio}%好评率</div>
          ) : (
            <GameRate score={(Number(soft?.score) / 20).toFixed(1)} />
          )}
          <div className="line" />
          <div>{soft.downloadCount}安装</div>
        </div>
      </div>
    </div>
    // </_LogInView>
  );
});
